import React from 'react';
import './ManagementPage.css';

function ManagementPage() {
  return (
    <div className="page management-page">
      <section className="management-hero">
        <div className="management-hero-content">
          <h1>Gestión</h1>
        </div>
      </section>

      <section className="management-content">
        <div className="content-container">
          <div className="intro-text">
            <h2 className="intro-title">Gestión Integral de Patrimonio Inmobiliario</h2>
            <p>
              TABIA Gestión es la compañía del Grupo TABIA especializada en la gestión patrimonial inmobiliaria, 
              con el objetivo de crear, preservar y maximizar el valor de las carteras inmobiliarias de nuestros clientes.
            </p>
            <p>
              Prestamos servicios a grupos familiares, compañías, fondos de inversión —nacionales e internacionales—, 
              así como a empresas industriales y de servicios interesadas en estructurar, desarrollar y mantener 
              carteras de activos inmobiliarios alineadas con sus objetivos estratégicos.
            </p>
            <p>
              Nuestro modelo de trabajo se basa en un enfoque integral y flexible, adaptado a las necesidades 
              específicas de cada cliente, que abarca todas las fases del ciclo de vida de la inversión inmobiliaria:
            </p>
          </div>

          <div className="services-list">
            <div className="service-item">
              <h3>Asesoramiento estratégico</h3>
              <p>
                En la definición de la cartera inmobiliaria, analizando la tipología de activos, su composición 
                y diversificación, tamaños, niveles de riesgo y rentabilidad, así como su adecuada localización.
              </p>
            </div>

            <div className="service-item">
              <h3>Identificación y ejecución de oportunidades</h3>
              <p>
                De inversión y desinversión, conforme a la estrategia previamente definida y a las condiciones 
                del mercado en cada momento.
              </p>
            </div>

            <div className="service-item">
              <h3>Acompañamiento continuo</h3>
              <p>
                En la gestión de la cartera, supervisando su evolución, optimizando su rendimiento y adaptándola 
                de forma dinámica a los cambios del entorno económico y del mercado inmobiliario.
              </p>
            </div>
          </div>

          <div className="closing-text">
            <p>
              Nuestra amplia experiencia en el sector nos permite realizar un análisis estratégico exhaustivo tanto 
              de los activos como de los mercados, evaluando de manera rigurosa los riesgos asociados a cada 
              operación y desarrollando estrategias de gestión y mitigación de riesgos orientadas a la protección 
              del capital.
            </p>
            <p>
              TABIA cuenta con un equipo altamente cualificado y multidisciplinar, que ofrece una gama de servicios 
              profesionales especializados destinados a complementar los proyectos de inversión inmobiliaria, 
              agilizar los procesos de toma de decisiones e impulsar el crecimiento y la consolidación patrimonial 
              de nuestros clientes.
            </p>
          </div>

          <div className="cards-section">
            <h2 className="cards-title">Desarrollamos el perfil de inversión, definiendo</h2>
            <div className="cards-grid">
              <div className="card">
                <h3>Tipología de activos</h3>
                <p>Análisis detallado de las diferentes tipologías de activos inmobiliarios para optimizar tu cartera de inversión.</p>
              </div>
            <div className="card">
              <h3>Estrategia fiscal y financiera</h3>
              <p>Planificación integral que optimiza la estructura fiscal y financiera de tus inversiones inmobiliarias.</p>
            </div>
            <div className="card">
              <h3>Estructura de rentabilidad esperada</h3>
              <p>Definición clara de objetivos de rentabilidad basados en análisis exhaustivos del mercado y proyecciones financieras.</p>
            </div>
            <div className="card">
              <h3>Niveles óptimos de apalancamiento</h3>
              <p>Estrategias de financiación equilibradas que maximizan el retorno minimizando el riesgo financiero.</p>
            </div>
            <div className="card">
              <h3>Plan de crecimiento y rotación de activos</h3>
              <p>Desarrollo de estrategias dinámicas para el crecimiento sostenible y la rotación eficiente de tu patrimonio.</p>
            </div>
          </div>
          </div>

          <div className="quote-with-bg-section" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/gestion-quote-bg.png)`,
            backgroundSize: '80%',
            backgroundPosition: '-50px center',
            backgroundRepeat: 'no-repeat'
          }}>
            <div className="quote-bg-overlay"></div>
            <div className="quote-bg-content">
              <blockquote className="quote-bg-text">
                <p>
                  "En Tabia Group concebimos el sector inmobiliario como una herramienta de creación de valor a largo plazo: 
                  identificamos oportunidades, estructuramos inversiones sólidas y gestionamos activos con una visión estratégica, 
                  profesional y orientada a la rentabilidad."
                </p>
                <footer className="quote-bg-author">
                  — David Pons Camps, Presidente de Tabia Group
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ManagementPage;
